import { z } from "zod";
import { responseSchema } from "../http.js";
import { countrySchema } from "./auth.js";
/**
 * ═══════════════════════════════════════════════════════════
 * Sedes
 *
 * Réplica de `shop/admin/manage-sedes` de producción (Anahí, 27-ago):
 * las ubicaciones físicas de It's The Best. Existen DESDE YA para que,
 * cuando entre la integración de envíos (Trasso), cada guía tenga de
 * dónde salir — la sede es el ORIGEN del envío. Mientras tanto son un
 * catálogo del panel: alta, edición y apagado.
 *
 * Se APAGAN, no se borran, cuando dejan de operar: una sede que ya
 * generó envíos es historia de esos envíos.
 * ═══════════════════════════════════════════════════════════
 */
export const sedeInputSchema = z.object({
    name: z
        .string()
        .trim()
        .min(2, "Escribe el nombre de la sede")
        .max(80, "Ese nombre es demasiado largo"),
    country: countrySchema,
    city: z.string().trim().min(2, "Escribe la ciudad").max(80),
    /** Calle, número, colonia y CP — lo que una guía de envío necesita. */
    address: z
        .string()
        .trim()
        .min(10, "Escribe la dirección completa: calle, número, colonia y CP")
        .max(300),
    /**
     * Estado y CP POR SEPARADO (integración Trasso, 27-ago): la cotización
     * los exige como campos propios, y una sede con ellos prellenan el
     * origen de cada guía sin reescribir nada. Opcionales para no romper
     * las sedes ya capturadas — el formulario de la guía los pide si faltan.
     */
    state: z.string().trim().max(60).optional(),
    zip: z
        .string()
        .trim()
        .regex(/^\d{5}$/, "El código postal son 5 dígitos")
        .optional(),
    phone: z.string().trim().max(30).optional(),
    active: z.boolean().default(true),
});
/** La edición admite cualquier subconjunto: cambiar el teléfono no
 * obliga a reescribir la dirección. */
export const sedeUpdateSchema = sedeInputSchema.partial();
export const sedeSchema = sedeInputSchema.extend({
    id: z.string(),
    createdAt: z.string(),
});
/** Filtros y paginación de SERVIDOR: nombre/ciudad y estado. */
export const sedeListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    perPage: z.coerce.number().int().min(1).max(100).default(24),
    query: z.string().trim().max(80).optional(),
    status: z.enum(["active", "inactive"]).optional(),
});
export const sedeListResponseSchema = responseSchema(z.object({
    items: z.array(sedeSchema),
    total: z.number().int().min(0),
    page: z.number().int().min(1),
    perPage: z.number().int().min(1),
}));
export const sedeResponseSchema = responseSchema(z.object({ sede: sedeSchema }));
export const SEDE_ROUTES = {
    adminList: "/api/admin/sedes",
    adminCreate: "/api/admin/sedes",
    adminOne: (id) => `/api/admin/sedes/${id}`,
};
//# sourceMappingURL=sede.js.map